// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"359":"487c9497","370":"e34085f9","543":"487c9497","997":"487c9497"}[chunkId] + ".chunk.css";
};